export default __webpack_public_path__ + "static/media/payment-method-truck.c89a2f8f.png";